import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface NutritionServiceFeConfig {
  /** Base endpoint for nutrient-api, e.g., '/nutrient-api' */
  endpoint?: string;
  /** Base endpoint for recipe-bucket, e.g., '/recipe-bucket' */
  recipeBucketEndpoint?: string;
}

export const NUTRITION_SERVICE_FE_CONFIG =
  new InjectionToken<NutritionServiceFeConfig>('NUTRITION_SERVICE_FE_CONFIG');

export function provideNutritionServiceFe(
  config: NutritionServiceFeConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: NUTRITION_SERVICE_FE_CONFIG,
      useValue: config,
    },
  ]);
}
